import { Component, inject, input } from '@angular/core';
import { LayoutService } from '../../core/services/layout.service';
import { IconComponent } from "../icons/icon.component";
import { IconNameType } from '../icons/icon-name-type.enum';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'cwo-view-order-button-round',
  standalone: true,
  imports: [IconComponent, CommonModule],
  templateUrl: './view-order-button-round.component.html',
  styleUrls: ['./view-order-button-round.component.css']
})
export class ViewOrderButtonRoundComponent {
  layout = inject(LayoutService);
  itemCount = input<number>(0);
  iconNameType = IconNameType;

}
